<p-dialog [(visible)]="displayHelpPopUp" [header]="dialogHeader" dismissableMask="true" modal="true">
  <div>
    <p>You may download the
      <ng-container *ngIf="!isQfd">Snapshot (QED)</ng-container>
      <ng-container *ngIf="isQfd">Price&Volume Signals (QFD)</ng-container>
      symbol list using wget or curl to the following URL:
    </p>
    <p *ngIf="!isQfd"><a href="https://portal.mckay-brothers.com/api/symbol_list?key=[key]">https://portal.mckay-brothers.com/api/symbol_list?key=[key]</a>
    </p>
    <p *ngIf="isQfd"><a href="https://portal.mckay-brothers.com/api/qfd_symbol_list?key=[key]">https://portal.mckay-brothers.com/api/qfd_symbol_list?key=[key]</a>
    </p>
    <p>
      Where key is your
      <a [routerLinkActiveOptions]="{exact: true}"
         routerLink="/{{currentUser.company.uniqid}}/{{currentUser.company.uniqid}}/{{currentUser.uniqid}}/edit"
         routerLinkActive="active">personal api key</a>.
    </p>
  </div>
</p-dialog>
<p-dialog [(visible)]="displayPastListsDialog" [focusOnShow]="false" [style]="{width: '620px'}"
          dismissableMask="true"
          header="Download past symbol lists" modal="true">
  <div *ngIf="researchForm" [formGroup]="researchForm">
    <p>Select a range of dates and click 'Download'. Only dates with a published symbol list are selectable.</p>
    <div class="past-range-controls">
      <label class="mb-0" for="past_date_filter_range_1">From date:</label>
      <p-calendar
        [disabledDates]="disabledDatesInCalendar"
        appendTo="body"
        formControlName="pastDateRange1"
        id="past_date_filter_range_1"
        panelStyleClass="sym-datepicker">
        <ng-template let-date pTemplate="date">
          <span [ngStyle]="{'color': '#2563eb', 'textDecoration': 'underline' }">{{ date.day }}</span>
        </ng-template>
      </p-calendar>
      <label class="mb-0" for="past_date_filter_range_2">To date:</label>
      <p-calendar
        [disabledDates]="disabledDatesInCalendar"
        appendTo="body"
        formControlName="pastDateRange2"
        id="past_date_filter_range_2"
        panelStyleClass="sym-datepicker">
        <ng-template let-date pTemplate="date">
          <span [ngStyle]="{'color': '#2563eb', 'textDecoration': 'underline' }">{{ date.day }}</span>
        </ng-template>
      </p-calendar>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button (click)="resetRangeDates()"
            icon="fa fa-refresh pr-2"
            iconPos="left"
            label="Reset"
            pButton
            type="button"></button>
    <button (click)="downloadQedSymbolsWithThisDateRange()"
            [disabled]="rangeDateNotSelected()"
            icon="fa fa-download pr-2"
            iconPos="left"
            id="download_past_file_with_date_range_button"
            label="Download"
            pButton
            type="button"></button>
  </ng-template>
</p-dialog>
<div class="symbols-title-row">
  <h3 class="mb-0">
    <b *ngIf="isQhf">Volume Signals (QHF): symbols</b>
    <b *ngIf="!isQhf && !isQfd">Snapshot: symbols</b>
    <b *ngIf="!isQhf && isQfd">Price&Volume Signals: symbols</b>
  </h3>
  <div class="symbols-title-meta">
    <span *ngIf="getCommentFromQedSymbolInfoData()">{{ getCommentFromQedSymbolInfoData() }}</span>
    <span *ngIf="!isQfd && qedSymbolsInfo?.updateAt">Updated on: {{ qedSymbolsInfo.updateAt }}</span>
    <span *ngIf="isQfd && qedSymbolsInfo?.updatedAt">Updated
      on: {{ qedSymbolsInfo.updatedAt | date: 'yyyy-MM-dd HH:mm:ss' }}</span>
    <i (click)="alterDisplayHelpPopUp()" *ngIf="!isQfd" class="fa fa-question-circle symbols-help"
       title="How to download via API"></i>
    <i *ngIf="isQfd" class="fa fa-question-circle symbols-help"
       pTooltip="File is not yet available for download. Please come back later."></i>
  </div>
</div>
<div *ngIf="alertQedSymbolHasNotChanged " class="alert alert-danger alert-dismissible fade show">
  This information is outdated. Please verify that the
  <ng-container *ngIf="isQhf">QHF</ng-container>
  <ng-container *ngIf="!isQhf && !isQfd">QED</ng-container>
  <ng-container *ngIf="!isQhf && isQfd">QFD</ng-container>
  symbol list has not changed.
</div>
<div *ngIf="error" class="alert alert-danger alert-dismissible fade show">
  {{ errorMessage }}
</div>
<div *ngIf="!alertQedSymbolHasNotChanged && !loading" [formGroup]="researchForm">
  <div class="symbols-filter">
    <label class="symbols-filter-label mb-0" for="qed_product_filter">Product</label>
    <p-dropdown (onChange)="filteredQedSymbolList()"
                [filter]="true"
                [options]="qedProductDropdown"
                [showClear]="true"
                formControlName="qedProduct"
                id="qed_product_filter"
                placeholder="All products"></p-dropdown>
    <label class="symbols-filter-label mb-0" for="channel_filter">Channel</label>
    <input (input)="filteredQedSymbolList()" class="form-control symbols-filter-input" formControlName="channel"
           id="channel_filter" placeholder="Filter…" type="text">
    <label class="symbols-filter-label mb-0" for="asset_class_filter">Asset class</label>
    <input (input)="filteredQedSymbolList()" class="form-control symbols-filter-input" formControlName="assetClass"
           id="asset_class_filter" placeholder="Filter…" type="text">
    <ng-container *ngIf="canSeeNextWeekSymbols && !isQfd">
      <span class="symbols-filter-sep"></span>
      <div class="symbols-pills">
        <button (click)="returnToCurrentSymbolList()" [class.on]="!isOnNextWeekMode" class="symbols-pill"
                type="button">Current week
        </button>
        <button (click)="displayNextWeekSymbols()" [class.on]="isOnNextWeekMode" class="symbols-pill"
                type="button">Next week
        </button>
      </div>
    </ng-container>
    <div class="symbols-filter-right">
      <button (click)="downloadMenu.toggle($event)" icon="fa fa-download pr-2" iconPos="left"
              id="download_csv_menu_button" label="Download CSV" pButton type="button"></button>
      <button (click)="resetTable()" icon="fa fa-refresh pr-2" iconPos="left" id="reset_button"
              label="Reset" pButton type="button"></button>
    </div>
  </div>
  <p-overlayPanel #downloadMenu styleClass="sym-download-menu">
    <div class="symbols-menu">
      <button (click)="downloadCurrentQdSymbolList(); downloadMenu.hide()" class="symbols-menu-item"
              id="download_csv_button" type="button">
        <i aria-hidden="true" class="fa fa-download"></i>This week's symbol list
      </button>
      <button (click)="downloadCurrentQdSymbolList(true); downloadMenu.hide()" *ngIf="!isQfd"
              class="symbols-menu-item" id="download_csv_with_instrument_id_button" type="button">
        <i aria-hidden="true" class="fa fa-download"></i>This week's symbol list, incl. instrument id
      </button>
      <button (click)="downloadNextWeekQfdSymbolList(); downloadMenu.hide()" *ngIf="isQfd"
              [disabled]="!canDownloadNextQFDSymbolList" class="symbols-menu-item"
              id="download_next_week_csv_button" type="button">
        <i aria-hidden="true" class="fa fa-download"></i>Next week's symbol list
        <span *ngIf="!canDownloadNextQFDSymbolList" class="symbols-menu-hint">not yet available</span>
      </button>
      <ng-container *ngIf="startDates">
        <div class="symbols-menu-sep"></div>
        <button (click)="displayPastListsDialog = true; downloadMenu.hide()" class="symbols-menu-item"
                id="past_lists_menu_item" type="button">
          <i aria-hidden="true" class="fa fa-calendar"></i>Past symbol lists…
        </button>
      </ng-container>
      <ng-container *ngIf="!isQfd">
        <div class="symbols-menu-sep"></div>
        <button (click)="alterDisplayHelpPopUp(); downloadMenu.hide()" class="symbols-menu-item"
                id="download_via_api_menu_item" type="button">
          <i aria-hidden="true" class="fa fa-link"></i>Download via API…
        </button>
      </ng-container>
    </div>
  </p-overlayPanel>
  <div *ngIf="noDataToDisplay()">
    <h3 class="symbols-no-data">No data for this week, please select another date</h3>
  </div>
  <ng-container *ngIf="!noDataToDisplay()">
    <div *ngFor="let market of marketList">
      <div *ngIf="qedSymbolList(market).length !== 0" class="symbols-market-table">
        <p-table (sortFunction)="tableService.customSort($event)" [columns]="cols" [customSort]="true"
                 [rowHover]="true" [rowTrackBy]="trackByFn"
                 [tableStyle]="{'table-layout':'auto'}" [value]="qedSymbolList(market)" id="companies-list-table">
          <ng-template pTemplate="caption">
            {{ market }} <span class="symbols-table-count">{{ qedSymbolList(market).length }} symbols</span>
          </ng-template>
          <ng-template let-columns pTemplate="header">
            <tr>
              <th *ngFor="let col of cols">
                {{ col.header }}
              </th>
            </tr>
          </ng-template>
          <ng-template let-qedSymbol pTemplate="body">
            <tr>
              <td *ngIf="!isQfd">{{ qedSymbol.marketName }}</td>
              <td>{{ qedSymbol.qedProduct }}</td>
              <td *ngIf="!isQfd" style="padding: 0">
                <button (click)="redirectionToQedMulticastPageWithGetParameter(qedSymbol.market, null)"
                        [disabled]="isOnNextWeekMode"
                        class="btn btn-link">{{ qedSymbol.market }}
                </button>
              </td>
              <td *ngIf="isQfd">
                {{ qedSymbol.qedChannelId.name }}
              </td>
              <td>{{ qedSymbol.assetClass }}</td>
              <td>{{ qedSymbol.product }}</td>
              <td>{{ htmlDecode(qedSymbol.name) }}</td>
              <td>{{ qedSymbol.instrumentId }}</td>
              <td>{{ qedSymbol.maturity }}</td>
              <td *ngIf="!isQfd" style="padding: 0">
                <button (click)="redirectionToQedMulticastPageWithGetParameter(null, qedSymbol.multicastAdress)"
                        [disabled]="isOnNextWeekMode"
                        class="btn btn-link">{{ qedSymbol.multicastAdress }}
                </button>
              </td>
              <td>{{ htmlDecode(qedSymbol.qedSymbol) }}</td>
              <td *ngIf="isQfd">{{ qedSymbol.qfdId }}</td>
              <td *ngIf="isQfd">{{ qedSymbol.removalDate | date : "MMM dd, y" }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div *ngIf="!isQfd" class="symbols-footer">
      <span><b>Production values X and Y:</b>
        <button [disabled]="isOnNextWeekMode"
                [routerLink]="isQhf ? '/qhf-symbols/multicast' : '/qed-symbols/multicast'"
                class="btn btn-link symbols-footer-link">See the Multicast IP list.
        </button>
      </span>
      <span><b>UAT values for Y:</b> {{ getUatValuesForYFromQedSymbolInfoData() }}</span>
    </div>
  </ng-container>
</div>
